import { render, staticRenderFns } from "./new-guidelines.vue?vue&type=template&id=434913ee&scoped=true"
import script from "./new-guidelines.vue?vue&type=script&lang=js"
export * from "./new-guidelines.vue?vue&type=script&lang=js"
import style0 from "./new-guidelines.vue?vue&type=style&index=0&id=434913ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434913ee",
  null
  
)

export default component.exports